import axios from "axios";

const URL = process.env.REACT_APP_API_URL;

const axiosApi = axios.create({
  baseURL: URL,
});

const token = localStorage.getItem("token");
if (token) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

let refresh = false;

axiosApi.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // 1. Excluir endpoints críticos
    const excludedEndpoints = [
      "/auth/login/",
      "/auth/token/refresh/"
    ];
    
    // 2. Manejar errores de red/CORS primero
    if (!error.response) {
      return Promise.reject({
        status: 0,
        message: "Error de red o CORS",
        isNetworkError: true,
        originalError: error
      });
    }

    // 3. Refresh token lógico
    if (status === 401 && 
        !refresh && 
        !excludedEndpoints.includes(originalRequest.url)) {
      
      refresh = true;
      
      try {
        const res = await axios.post(
          `${URL}/auth/token/refresh/`,
          {},
          { withCredentials: true }
        );

        if (res.status === 200) {
          // 4. Usar propiedad consistente para el token
          const newAccessToken = res.data.access;
          
          // Actualizar token globalmente
          axiosApi.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          
          // Actualizar token para esta solicitud
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          
          // Guardar nuevo token si es necesario
          localStorage.setItem("token", newAccessToken);
          
          refresh = false;
          return axiosApi(originalRequest);
        }
      } catch (refreshError) {
        // 5. Manejo completo del error
        console.error("Refresh token failed:", refreshError);
        
        // Limpiar almacenamiento
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        
        // Redirigir
        window.location.href = "/login";
        
        // Rechazar PROMESA correctamente
        return Promise.reject({
          status: refreshError.response?.status || 401,
          message: "La sesión ha expirado",
          isSessionExpired: true
        });
      } finally {
        refresh = false; // Siempre restablecer el flag
      }
    }

    // 6. Rechazar con estructura consistente
    return Promise.reject({
      status: status || 500,
      data: error.response?.data || null,
      message: error.message,
      originalError: error
    });
  }
);
export const get = async (url) => {
  const res = await axiosApi.get(url);
  return res;
};

export const getFile = async (url) => {
  const res = await axiosApi.get(url, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/zip, application/octet-stream, */*'
    }
  });
  return res;
};

export const post = async (url, data = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };
  const res = await axiosApi.post(url, data, config);
  return res;
};

export const postFormData = async (url, formData) => {
  const config = {
    headers: {
      // No establecer Content-Type para FormData, axios lo hará automáticamente
    },
    withCredentials: true,
  };
  const res = await axiosApi.post(url, formData, config);
  return res;
};

export const patch = async (url, data = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };
  const res = await axiosApi.patch(url, data, config);
  return res;
};

export const patchFormData = async (url, formData) => {
  const config = {
    headers: {
      // No establecer Content-Type para FormData, axios lo hará automáticamente
    },
    withCredentials: true,
  };
  const res = await axiosApi.patch(url, formData, config);
  return res;
};

export const put = async (url, data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };
  const res = await axiosApi.put(url, data, config);
  return res;
};

export const del = async (url) => {
  const res = await axiosApi.delete(url);
  return res;
};
export default axiosApi;
